import { NavLink } from "react-router-dom";
import { useGetToursQuery } from "../../tours/toursApiSlice";
import { TourObj } from "../../../shared/types";
import TourCard from "../../tours/AllTours/TourCard";
import Reveal from "../../../shared/design/Reveal";
import Eyebrow from "../../../shared/design/Eyebrow";
import Container from "../../../shared/design/Container";

const FeaturedTours = () => {
  const { data, isSuccess } = useGetToursQuery("");
  const tours: TourObj[] =
    isSuccess && data ? data.data.data.slice(0, 3) : [];

  if (!tours.length) return null;

  return (
    <Container className="py-8">
      <div className="mb-[34px] flex items-end justify-between">
        <div>
          <Eyebrow className="mb-2.5">02 — THE COLLECTION</Eyebrow>
          <h2 className="font-serif text-[32px] font-normal tracking-[-0.02em] md:text-[42px]">
            Trips worth the dirt on your boots
          </h2>
        </div>
        <NavLink
          to="/tours"
          className="wn-link whitespace-nowrap text-[14.5px] font-semibold text-ink"
        >
          View all →
        </NavLink>
      </div>
      <div className="grid grid-cols-1 gap-[26px] md:grid-cols-2 lg:grid-cols-3">
        {tours.map((tour, i) => (
          <Reveal key={tour.id} delay={i * 0.08}>
            <TourCard tourObj={tour} />
          </Reveal>
        ))}
      </div>
    </Container>
  );
};

export default FeaturedTours;
